import { App_Url, getWhatsAppUrl } from "@/src_new/whiteLabel";
import { App_Url_New } from "../common/static";
import { openModal } from "../redux/reducers/uiSlice";
import { useAppDispatch } from "../redux/store/hooks";
import { usePosterReducers } from "../redux/store/useGetData";

const CHATBOT_BASE_URL = import.meta.env.VITE_APP_CHATBOT_URL_RE;

const getChatbotBaseUrl = () => CHATBOT_BASE_URL.replace(/\/+$/, "");

export default function FloatingButtons() {
  const openWhatsApp = () => {
    window.open(getWhatsAppUrl(), "_blank", "noopener,noreferrer");
  };
  const { auth: user } = usePosterReducers();
  const dispatch = useAppDispatch();
  const isAuthenticated = Boolean(user.user?.access_token);

  const openChatbot = () => {
    const iframeUrl = getChatbotBaseUrl();

    dispatch(
      openModal({
        name: App_Url_New.PopupKeys.OPEN_CHAT_BOT,
        data: {
          iframeUrl,
        },
      })
    );
  };

  const buttonClass =
    "flex items-center justify-center rounded-full " +
    "w-12 h-12 md:w-14 md:h-14 " +
    "bg-transparent shadow-lg " +
    "transition-transform duration-200 hover:scale-105 active:scale-95";

  const iconClass = "w-10 h-10 md:w-12 md:h-12 object-contain";

  const containerPosition = isAuthenticated
    ? "fixed bottom-4 left-4 md:bottom-6 md:left-6"
    : "fixed bottom-4 right-4 md:bottom-6 md:right-6";
  return (
    <div className={`${containerPosition} z-40 flex flex-col gap-2 md:gap-3`}>
      {/* WhatsApp Button */}
      {!isAuthenticated && (
        <button
          type="button"
          aria-label="Chat on WhatsApp"
          onClick={openWhatsApp}
          className={buttonClass}
        >
          <img src={App_Url.public.Whatsapp} alt="WhatsApp" className={iconClass} />
        </button>
      )}

      {/* Chatbot Button */}
      <button type="button" aria-label="Open Chatbot" onClick={openChatbot} className={buttonClass}>
        <img src={App_Url.public.ChatBot} alt="Chatbot" className={iconClass} />
      </button>
    </div>
  );
}
